import React, {
  Suspense,
} from 'react';
import {
  Redirect,
  Router,
  Switch
} from 'react-router-dom';
import { createHashHistory } from 'history';
import {
  ELSPageLoader,
  ELSAccessibilityFocusState,
} from '@els/els-ui-common-react';
import { ELSModalProvider } from '@els/els-component-modal-react';
import {
  IntlProvider,
} from 'react-intl';
import {
  setDefaultAppConfig
} from './app.config';
import ErrorBoundary from '../error-boundary/ErrorBoundary.component';
import LocationChangeHandler from '../location-change-handler/LocationChangeHandler.component';
import { RoutePath } from './app.constants';
import '../../assets/main.scss';
import {
  getLanguage,
  messages
} from '../../utilities/app.utilities';
import AppProvider from './AppProvider.component';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import AnalyticsRegistrar from '../analytics-registrar/AnalyticsRegistrar.component';
import MessagesRegistrar from '../messages-registrar/MessagesRegistrar.component';
import WelcomeDisclaimerRegistrar from '../welcome-disclaimer-registrar/WelcomeDisclaimerRegistrar.component';
import AppRegistrar from './AppRegistrar.component';
import MaintenanceHandler from '../maintenance-handler/MaintenanceHandler.component';
import { createRoute } from './app-route.utilities';
import { getAppRoutes } from './app.routes';
import { RecordEmpty } from '../../models/common.models';
import ThemeHandler from '../theme-handler/ThemeHandler.component';
import IdleHandler from './IdleHandler.component';

setDefaultAppConfig();
const history = createHashHistory<RecordEmpty>();
const HTMLHeadSEOComponent = withHTMLHeadSEO(null)(null);

const App = (): JSX.Element => {
  return (
    <AppProvider>
      <IntlProvider locale={getLanguage()} messages={messages[getLanguage()]}>
        <ErrorBoundary>
          <Router history={history}>
            <ELSModalProvider>
              <>
                <AppRegistrar />
                <HTMLHeadSEOComponent />
                <AnalyticsRegistrar />
                <WelcomeDisclaimerRegistrar />
                <MessagesRegistrar />
                <LocationChangeHandler />
                <MaintenanceHandler />
                <ThemeHandler />
                <Suspense fallback={<ELSPageLoader />}>
                  <Switch>
                    {
                      getAppRoutes()
                        .map((route) => createRoute(route))
                    }
                    <Redirect from="/" exact to={RoutePath.NOT_AUTHORIZED} />
                    <Redirect to={RoutePath.PAGE_NOT_FOUND} />
                  </Switch>
                </Suspense>
              </>
            </ELSModalProvider>
          </Router>
          <ELSAccessibilityFocusState />
          <IdleHandler history={history} />
        </ErrorBoundary>
      </IntlProvider>
    </AppProvider>
  );
};
export default App;
